import * as constants from './constants'
import { fetchAsJson, postAsJson } from '@eig-builder/core-utils/helpers/fetch-helper'
import { getUrl, siteNames } from '@eig-builder/core-utils/helpers/url-helper'

export const getInvoices = (accountId, partnerId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/invoices/invoices2'), {
    key: constants.GET_INVOICES,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const disregardInvoice = (invoiceId, accountId, partnerId) => {
  return postAsJson(
    getUrl(siteNames.API_CRM, `/v1.0/invoices/disregard/${invoiceId}`),
    {},
    {
      key: constants.POST_DISREGARD_INVOICE,
      returnType: 'text/plain'
    },
    {
      'X-CRM-AccountId': accountId,
      'X-CRM-PartnerId': partnerId
    }
  )
}

export const resetDisregardInvoiceResponse = () => ({
  type: constants.POST_DISREGARD_INVOICE_RESET
})

export const getCredits = (accountId, partnerId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/credits/all'), {
    key: constants.GET_CREDITS,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}

export const getRefunds = (accountId, partnerId) => {
  return fetchAsJson(getUrl(siteNames.API_CRM, '/v1.0/refunds/all'), {
    key: constants.GET_REFUNDS,
    convertToCamelCase: true,
    fetchOptions: {
      headers: {
        'X-CRM-AccountId': accountId,
        'X-CRM-PartnerId': partnerId
      }
    }
  })
}
